export const RealityCheckOptions = {
  0: "none",
  1: "realityCheck10M",
  2: "realityCheck20M",
  3: "realityCheck30M",
  4: "realityCheck40M",
  5: "realityCheck50M",
  6: "realityCheck1H",
  7: "realityCheck2H",
  8: "realityCheck3H",
  9: "realityCheck4H",
  10: "realityCheck5H",
  11: "realityCheck6H"
}


export const RealityCheckStatusEnum = {
  /// Reality check is enabled for player.
  Enabled: 1, // 
  // Reality check is enabled brand level. 
  EnabledBrandLevel: 2,
  /// Reality check is disabled from standards. 
  Disabled: 3
}
